import React, { FC } from 'react'
import { makeStyles } from '@material-ui/styles'
import classNames from 'classnames'

import StylesModule from 'components/lv1/responsiveImage.module.scss'

import AnimeArea from 'components/lv2/AnimeArea'

export interface responsiveImageProps {
  imageSrc: string
  imageAlt: string
  aspect: {
    mb: {
      x: number
      y: number
    }
    tb: {
      x: number
      y: number
    }
    pc: {
      x: number
      y: number
    }
  }
}
const responsiveMobileMin = '375px'
const responsiveTabletMin = '768px'
const responsivePcMin = '1024px'

const responsiveImage: FC<responsiveImageProps> = ({
  imageSrc,
  imageAlt,
  aspect,
}) => {
  const aspectRatioMB = (100 * aspect.mb.y) / aspect.mb.x
  const aspectRatioTB = (100 * aspect.tb.y) / aspect.tb.x
  const aspectRatioPC = (100 * aspect.pc.y) / aspect.pc.x
  const useStyles = makeStyles(() => ({
    ImageWidth: {
      width: `100%`,
      [`@media (min-width:${responsiveMobileMin})`]: {
        width: `${aspect.mb.x}px`,
      },
      [`@media (min-width:${responsiveTabletMin})`]: {
        width: `${aspect.tb.x}px`,
      },
      [`@media (min-width:${responsivePcMin})`]: {
        width: `${aspect.pc.x}px`,
      },
    },
    ImageBG: {
      backgroundImage: `url(${imageSrc})`,
      paddingTop: `${aspectRatioMB}%`,
      [`@media (min-width:${responsiveTabletMin})`]: {
        paddingTop: `${aspectRatioTB}%`,
      },
      [`@media (min-width:${responsivePcMin})`]: {
        paddingTop: `${aspectRatioPC}%`,
      },
    },
  }))
  const classes = useStyles()
  const AriaHidden = imageAlt ? false : true
  return (
    <div
      className={classNames(StylesModule.responsiveImage, classes.ImageWidth)}
      role="img"
      aria-label={imageAlt}
      aria-hidden={AriaHidden}
    >
      <AnimeArea>
        <span
          className={classNames(
            StylesModule.responsiveImage__image,
            classes.ImageBG,
          )}
          role="img"
          aria-label={imageAlt}
          aria-hidden={AriaHidden}
        ></span>
      </AnimeArea>
    </div>
  )
}

export default responsiveImage
